"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
exports.addNewChain = exports.switchChain = exports.trackWallet = exports.listenChainChanged = exports.listenAccountsChanged = exports.getChainId = exports.selectAccounts = exports.requestAccounts = exports.getProvider = exports.ethersProviders = void 0;
var ethers_1 = require("ethers");
var lodash_partition_1 = __importDefault(require("lodash.partition"));
var rxjs_1 = require("rxjs");
var operators_1 = require("rxjs/operators");
var disconnect_1 = __importDefault(require("./disconnect"));
var actions_1 = require("./store/actions");
var index_1 = require("./store/index");
var streams_1 = require("./streams");
exports.ethersProviders = {};
function getProvider(chain) {
    // @ts-ignore - This is a hack to get around the fact that the `chain` object
    if (!chain)
        return null;
    if (!exports.ethersProviders[chain.rpcUrl]) {
        exports.ethersProviders[chain.rpcUrl] = new ethers_1.providers.StaticJsonRpcProvider(chain.providerConnectionInfo && chain.providerConnectionInfo.url
            ? chain.providerConnectionInfo
            : chain.rpcUrl);
    }
    return exports.ethersProviders[chain.rpcUrl];
}
exports.getProvider = getProvider;
function requestAccounts(provider) {
    var args = { method: 'eth_requestAccounts' };
    return provider.request(args);
}
exports.requestAccounts = requestAccounts;
function selectAccounts(provider) {
    var args = { method: 'eth_selectAccounts' };
    return provider.request(args);
}
exports.selectAccounts = selectAccounts;
function getChainId(provider) {
    return provider.request({ method: 'eth_chainId' });
}
exports.getChainId = getChainId;
function listenAccountsChanged(args) {
    var provider = args.provider, disconnected$ = args.disconnected$;
    var addHandler = function (handler) {
        provider.on('accountsChanged', handler);
    };
    var removeHandler = function (handler) {
        provider.removeListener('accountsChanged', handler);
    };
    return (0, rxjs_1.fromEventPattern)(addHandler, removeHandler).pipe((0, operators_1.takeUntil)(disconnected$));
}
exports.listenAccountsChanged = listenAccountsChanged;
function listenChainChanged(args) {
    var provider = args.provider, disconnected$ = args.disconnected$;
    var addHandler = function (handler) {
        provider.on('chainChanged', handler);
    };
    var removeHandler = function (handler) {
        provider.removeListener('chainChanged', handler);
    };
    return (0, rxjs_1.fromEventPattern)(addHandler, removeHandler).pipe((0, operators_1.takeUntil)(disconnected$));
}
exports.listenChainChanged = listenChainChanged;
function trackWallet(provider, label) {
    var _this = this;
    var disconnected$ = streams_1.disconnectWallet$.pipe((0, operators_1.filter)(function (wallet) { return wallet === label; }), (0, operators_1.take)(1));
    var accountsChanged$ = listenAccountsChanged({
        provider: provider,
        disconnected$: disconnected$
    }).pipe((0, operators_1.share)());
    // when account changed, set it to first account and subscribe to events
    accountsChanged$.subscribe(function (_a) {
        var address = _a[0];
        return __awaiter(_this, void 0, void 0, function () {
            var wallets, accounts, _b, existingAccount, restAccounts;
            return __generator(this, function (_c) {
                // no address, then no account connected, so disconnect wallet
                // this could happen if user locks wallet,
                // or if disconnects app from wallet
                if (!address) {
                    (0, disconnect_1["default"])(label);
                    return [2 /*return*/];
                }
                wallets = index_1.state.get().wallets;
                accounts = wallets.find(function (wallet) { return wallet.label === label; }).accounts;
                _b = (0, lodash_partition_1["default"])(accounts, function (account) { return account.address === address; }), existingAccount = _b[0][0], restAccounts = _b[1];
                // update accounts without ens and balance first
                (0, actions_1.updateWallet)(label, {
                    accounts: __spreadArray([
                        existingAccount || { address: address, ens: null, balance: null }
                    ], restAccounts, true)
                });
                return [2 /*return*/];
            });
        });
    });
    // also when accounts change, update Balance and ENS
    accountsChanged$
        .pipe((0, operators_1.switchMap)(function (_a) {
        var address = _a[0];
        return __awaiter(_this, void 0, void 0, function () {
            return __generator(this, function (_b) {
                if (!address)
                    return [2 /*return*/];
                // const { wallets } = state.get();
                // const { chains: walletChains } = wallets.find(
                //   wallet => wallet.label === label,
                // ) as WalletState;
                // const [connectedWalletChain] = walletChains;
                // const chain = chains.find(
                //   ({ namespace, id }) =>
                //     namespace === 'evm' && id === connectedWalletChain.id
                // ) as Chain;
                // const balanceProm = getBalance(address, chain)
                // const account = accounts.find(account => account.address === address)
                // const ensProm = account.ens
                //   ? Promise.resolve(account.ens)
                //   : validEnsChain(connectedWalletChain.id)
                //   ? getEns(address, chain)
                //   : Promise.resolve(null)
                return [2 /*return*/, Promise.all([Promise.resolve(address) /*, balanceProm */])];
            });
        });
    }))
        .subscribe(function (res) {
        if (!res)
            return;
        var address = res[0];
        (0, actions_1.updateAccount)(label, address, {});
    });
    var chainChanged$ = listenChainChanged({ provider: provider, disconnected$: disconnected$ }).pipe((0, operators_1.share)());
    // Update chain on wallet when chainId changed
    chainChanged$.subscribe(function (chainId) { return __awaiter(_this, void 0, void 0, function () {
        var wallets, _a, chains, accounts, connectedWalletChain, resetAccounts;
        return __generator(this, function (_b) {
            wallets = index_1.state.get().wallets;
            _a = wallets.find(function (wallet) { return wallet.label === label; }), chains = _a.chains, accounts = _a.accounts;
            connectedWalletChain = chains[0];
            if (chainId === connectedWalletChain.id)
                return [2 /*return*/];
            resetAccounts = accounts.map(function (_a) {
                var address = _a.address;
                return ({
                    address: address,
                    ens: null,
                    balance: null
                });
            });
            (0, actions_1.updateWallet)(label, {
                chains: [{ namespace: 'evm', id: chainId }],
                accounts: resetAccounts
            });
            return [2 /*return*/];
        });
    }); });
    // when chain changes get ens and balance for each account for wallet
    chainChanged$
        .pipe((0, operators_1.switchMap)(function () { return __awaiter(_this, void 0, void 0, function () {
        var wallets, accounts;
        var _this = this;
        return __generator(this, function (_a) {
            wallets = index_1.state.get().wallets;
            accounts = wallets.find(function (wallet) { return wallet.label === label; }).accounts;
            // const chain = chains.find(
            //   ({ namespace, id }) => namespace === 'evm' && id === chainId,
            // );
            return [2 /*return*/, Promise.all(accounts.map(function (_a) {
                    var address = _a.address;
                    return __awaiter(_this, void 0, void 0, function () {
                        return __generator(this, function (_b) {
                            // const balanceProm = getBalance(address, chain)
                            // const ensProm = validEnsChain(chainId)
                            //   ? getEns(address, chain)
                            //   : Promise.resolve(null)
                            // const [balance, ens] = await Promise.all([balanceProm, ensProm])
                            return [2 /*return*/, {
                                    address: address,
                                    balance: null,
                                    ens: null
                                }];
                        });
                    });
                }))];
        });
    }); }))
        .subscribe(function (updatedAccounts) {
        updatedAccounts && (0, actions_1.updateWallet)(label, { accounts: updatedAccounts });
    });
    disconnected$.subscribe(function () {
        provider.disconnect && provider.disconnect();
    });
}
exports.trackWallet = trackWallet;
function switchChain(provider, chainId) {
    return provider.request({
        method: 'wallet_switchEthereumChain',
        params: [{ chainId: chainId }]
    });
}
exports.switchChain = switchChain;
function addNewChain(provider, chain) {
    return provider.request({
        method: 'wallet_addEthereumChain',
        params: [
            {
                chainId: chain.id,
                chainName: chain.label,
                nativeCurrency: {
                    name: chain.label,
                    symbol: chain.token,
                    decimals: 18
                },
                rpcUrls: [chain.publicRpcUrl || chain.rpcUrl],
                blockExplorerUrls: chain.blockExplorerUrl
                    ? [chain.blockExplorerUrl]
                    : undefined
            },
        ]
    });
}
exports.addNewChain = addNewChain;
